export default {
  type: "tax-groups",
  name: null,
  country_code: null,
  excerpt: null,
  active: true,
  relationshipNames: ["taxes", "organization"],
  taxes: [],
  organization: {
    type: "organizations",
    id: null,
  },
};
